import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EstadosLaboratorio } from './estados-laboratorio.model';


export const entityEstadosLaboratorioAdapter: EntityAdapter<EstadosLaboratorio> =
  createEntityAdapter<EstadosLaboratorio>({
    selectId: (model) => model.id,
    sortComparer: (a: EstadosLaboratorio, b: EstadosLaboratorio): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityEstadosLaboratorioState extends EntityState<EstadosLaboratorio> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityEstadosLaboratorioState =
entityEstadosLaboratorioAdapter.getInitialState({
    isLoading: false,
    error: null
  });
